interface UserWithRoles {
  roles?: string[];
  [key: string]: unknown;
}

export function getTokenRolesByNamespace(user: unknown): string[] {
  if (!user || typeof user !== "object") {
    return [];
  }

  const roleNamespace = `https://${import.meta.env.VITE_AUTH0_DOMAIN}/roles`;
  const normalizedUser = user as UserWithRoles;
  if (!normalizedUser || !Array.isArray(normalizedUser[roleNamespace])) {
    return [];
  }

  const filteredRoles = normalizedUser[roleNamespace].filter(
    (role): role is string => typeof role === "string",
  );
  return filteredRoles;
}

export function hasOrgAdminRole(
  user: unknown,
  orgAdminRoles: string[] = [],
): boolean {
  if (orgAdminRoles.length === 0) {
    return false;
  }

  return getTokenRolesByNamespace(user).some((role) =>
    orgAdminRoles.includes(role),
  );
}
